/* eslint-disable @typescript-eslint/no-explicit-any */
import { Emitter } from 'mitt'

export enum PhoneStatusTypes {
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  REGISTERING = 'REGISTERING',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED',
  TERMINATED = 'TERMINATED',
}

export enum CallStatusTypes {
  PRECONNECT = 'PRECONNECT',
  INITIATING = 'INITIATING',
  RINGING = 'RINGING',
  ANSWERED = 'ANSWERED',
  TERMINATED = 'TERMINATED',
  ON_HOLD = 'ON_HOLD',
}

export enum ConferenceTypes {
  CALL = 1,
  USER,
}

export enum Events {
  PHONE_STATUS = 'phone:status',
  CALL_STATUS = 'call:status',
  CONFERENCE_JOINING = 'conference:joining',
  CONFERENCE_LEAVING = 'conference:leaving',
}

export enum SpyTypes {
  LISTEN = 'LISTEN',
  WHISPER = 'WHISPER',
  BARGE = 'BARGE',
}

export interface PhoneStatusEvent {
  status: PhoneStatusTypes
  error?: any
}

export interface CallStatusEvent {
  status: CallStatusTypes
  error?: any
}

export interface ConferenceJoiningEvent {
  roomId: any
}

export interface PhoneOptions {
  reconnectionAttempts?: number
  reconnectionDelay?: number
  shouldBeConnected?: boolean
  debug?: boolean
  disableEvents?: boolean
}

export interface CallOptions {
  prefix?: string
  clid?: string
  trunkName?: string
  duelRing?: boolean
}

export enum CallType {
  inboundCalls = 'inboundCalls',
  campaignListCalls = 'campaignListCalls',
  customCalls = 'customCalls',
}
// export default interface Call {
//   type: 'calls'
//   attributes: {
//     legacyId?: number
//     callType?: CallType
//     inbound?: boolean
//     killed?: boolean
//     sipCode?: number
//     number?: string
//     additionalData?: any
//     callStatus?: string
//     billingSeconds?: number
//     callDuration?: number
//     asteriskServerIp?: string
//     asteriskChannelId?: string
//     recordingFileName?: string
//     gatewayIp?: string
//     gatewayChannelId?: string
//     failoverRecordingName?: string
//     queueEnteredAt?: string
//     transferredAt?: string
//     createdAt?: string
//     updatedAt?: string
//   }
//   relationships: {
//     user?: JSONApiRelation
//     trunk?: JSONApiRelation
//     organization?: JSONApiRelation
//     extension?: JSONApiRelation
//     queue?: JSONApiRelation
//     campaign?: JSONApiRelation
//     campaignList?: JSONApiRelation
//     listRecord?: JSONApiRelation
//     disposition?: JSONApiRelation
//     campaignListRecordContactDetail?: JSONApiRelation
//     parent?: JSONApiRelation
//     conferenceCalls?: JSONApiRelationList
//   }
// }

export interface PhoneEvents {
  [Events.PHONE_STATUS]: (event: PhoneStatusEvent) => void
  [Events.CALL_STATUS]: (event: CallStatusEvent) => void
  [Events.CONFERENCE_JOINING]: (event: ConferenceJoiningEvent) => void
  [Events.CONFERENCE_LEAVING]: (event: null) => void
}

//@ts-expect-error Emitter Spec Changed
export declare interface PhoneEmitter extends Emitter {
  on<U extends keyof PhoneEvents>(event: U, listener: PhoneEvents[U]): void

  emit<U extends keyof PhoneEvents>(
    event: U,
    ...args: Parameters<PhoneEvents[U]>
  ): void
}
